import { useModalState } from '@/hooks/useModalState';
import { AIOnboardingModal } from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModal';
import {
  AIOnboardingModalVariant,
  OpenAIOnboardingModalProps,
} from '@/modules/aiOnboarding/AIOnboardingModal/AIOnboardingModal.types';
import { AiSuggestionForReviewCard } from '@/modules/aiSuggestions/aiSuggestions.contracts';
import { useRequiredHouseholdId } from '@/modules/household/contexts/useRequiredHouseholdId';

interface OpenOnboardingModalState {
  initialSelectedSuggestion?: AiSuggestionForReviewCard;
}

export function useReviewSuggestionOnboardingModal({
  suggestions,
  variant,
}: {
  suggestions: AiSuggestionForReviewCard[];
  variant:
    | AIOnboardingModalVariant.TRUST_ENTITIES
    | AIOnboardingModalVariant.BUSINESS_ENTITIES;
}) {
  const householdId = useRequiredHouseholdId();
  const [modalState, modal] = useModalState<OpenOnboardingModalState>();

  return {
    open: ({
      initialSelectedSuggestion,
    }: Pick<OpenAIOnboardingModalProps, 'initialSelectedSuggestion'>) =>
      modal.openModal({ initialSelectedSuggestion }),
    modal: modalState.isModalOpen ? (
      <AIOnboardingModal
        isOpen
        onClose={() => modal.closeModal()}
        householdId={householdId}
        variant={variant}
        initialSelectedSuggestion={modalState.data?.initialSelectedSuggestion}
        suggestionsWhere={{
          idIn: suggestions.map(({ id }) => id),
          acceptanceStatusIsNil: true,
        }}
        skipNavigationOnComplete
      />
    ) : null,
  };
}
